import {enumRemap} from 'shared/utils';
import {PeriodType} from '../../types';

export function isTrackDateOption(value: string) {
	const previousSelectedMarkingPeriodValue = enumRemap(PeriodType.PreviousSelectedMarkingPeriod, PeriodType);

	return value.startsWith(previousSelectedMarkingPeriodValue);
}
